<template>
    <div>
        <div v-if="contest">
            <contest-header/>
        </div>
        <div>
            <div
                v-if="contest"
            >
                <h1
                    class="text-5xl text-center my-5"
                >
                    Gallery
                </h1>
                <div
                    class="text-center mb-5"
                >
                    <div v-html="contest.gallery_content" />
                </div>
                <SortFilter
                    :change-item-order="changeItemOrder"
                    :handle-search="handleSearch"
                    :set-search-input="setSearchInput"
                >
                </SortFilter>

                <div id="scrollTo">
                </div>
            </div>
            <div id="card-deck-container">
                <div
                    class="card-deck thumbnails" id="card-list"
                    v-if="entries.length"
                >
                    <entry-card
                        v-for="entry in entries"
                        :key="entry.id"
                        :entry="entry"
                        imageSize="thumb">
                    </entry-card>
                </div>
            </div>
            <paginate
                :value="pageNum"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="changePage"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
            </paginate>
            <div id="vote-alert" style="opacity: 0;">
                <div class="text"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {ENV_URL, API_URL, MAIN_URL, STRIPE_PUBLISHABLE, S3_URL} from '@/js/environment.js';
import EntryCard from '@/js/components/contests/EntryCard.vue';
import ContestHeader from '@/js/components/contests/ContestHeader.vue';
import Paginate from '@/js/components/Paginate.vue';
import SortFilter from "@/js/components/SortFilter.vue";
import queryString from 'qs';
import vSelect from '../vue-select';
// import mediumZoom from '../../../node_modules/medium-zoom/dist/medium-zoom.js';
// import mediumZoom from './medium-zoom.js';

var smoothScroll = require('smoothscroll');

export default {
    components: {
        EntryCard,
        ContestHeader,
        Paginate,
        SortFilter,
        'v-select': vSelect,
    },
    data() {
        return {
            places: null,
            displayMobileFilters: false,
            is_loading: false,
            MAIN_URL: MAIN_URL,
            API_URL: API_URL,
            search_text: '',
            selectOptions: [
                {value: 'created_at-desc', label: 'Newest to Oldest'},
                {value: 'created_at-asc', label: 'Oldest to Newest'},
            ],
            orderBy: '',
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        page() {
            return this.$store.state.page;
        },
        contest() {
            return this.$store.state.contest;
        },
        entriesData() {
            return this.$store.state.entriesData;
        },
        entries () {
            return this.$store.state.entries;
        },
        pageNum() {
            return this.$route.query['page'] ? Number(this.$route.query['page']) : 1;
        },
        pageCount() {
            return this.$store.state.entriesData.last_page ? this.$store.state.entriesData.last_page : 1;
        },
        category() {
            return this.$route.query['categories'] ? this.$route.query['categories'] : "";
        },
    },
    created() {
        this.getEntries();
    },
    methods: {
        getEntries () {
            this.$store.dispatch('LOADING', true);
            const uri = ENV_URL + this.$route.path;
            let query = Object.assign({}, this.$route.query);
            const search = '?' + queryString.stringify(query);
            this.$store.dispatch('CONTESTS_CONTEST_ENTRIES', {uri: uri, search: search})
        },
        changePage(pageNum) {
            let query = Object.assign({}, this.$route.query);
            query['page'] = pageNum;
            this.$router.push({path: this.$route.path, query: query})
            var destToScroll = document.getElementById('scrollTo');
            smoothScroll(destToScroll);
        },
        changeItemOrder(val) {
            // this.orderBy = newVal;
            const order_values = val.split("-");
            const sort_order = order_values[0];
            const order_direction = order_values[1];
            let query = Object.assign({}, this.$route.query);
            query['order'] = sort_order;
            query['order_direction'] = order_direction;
            delete query['page'];
            this.$router.push({path: this.$route.path, query: query})
        },
        handleSearch(e) {
            e.preventDefault();
            let query = Object.assign({}, this.$route.query);
            query['search'] = this.search_text;
            delete query['page'];
            this.$router.push({path: this.$route.path, query: query})
        },
        setSearchInput(e) {
            this.search_text = e.target.value
        },
    },


    watch: {
        '$route'(to, from) {
            this.$store.dispatch('LOADING', true);
            const uri = ENV_URL + this.$route.path;
            let query = Object.assign({}, this.$route.query);
            const search = '?' + queryString.stringify(query);
            this.$store.dispatch('CONTESTS_CONTEST_ENTRIES', {uri: uri, search: search})
            // if (window !== undefined) {
            //     console.log('fullPath', to.fullPath);
            //     this.$ga.set(to.fullPath);
            //     this.$ga.page(to.fullPath);
            //
            // }
        }
    },
}
</script>

<style lang="scss">

</style>

